import styled from 'styled-components'
import PropTypes from 'prop-types'

import { Heading as HeadingBase } from '@h2/components/typography/heading'
import { PB97T, PB90T } from '@h2/components/colors'
import { container } from '@h2/components/mixins'

import { usePageTitle } from '../hooks/usePageTitle'

const Header = styled.header`
  background-color: ${PB97T};
  border-top: 1px solid ${PB90T};
  border-bottom: 1px solid ${PB90T};
  height: 68px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  grid-area: title;
`
const Heading = styled(HeadingBase)`
  ${container};
  display: flex;
  align-items: center;

  > span[role='img'] {
    margin-right: 15px;
  }
`
const Title = ({ children, icon: Icon }) => {
  usePageTitle(children)

  return (
    <Header>
      <Heading level="1" mb="0">
        {Icon && <Icon size="large" />}
        {children}
      </Heading>
    </Header>
  )
}

Title.propTypes = {
  icon: PropTypes.elementType,
  children: PropTypes.string.isRequired
}
Title.slotName = 'PageTitle'
Title.area = 'title'

export { Title }
